
const JPEGExif = {
  mapping: {
    1: { degrees: 0, reflectVertical: false, reflectHorizontal: false },
    2: { degrees: 0, reflectVertical: false, reflectHorizontal: true },
    3: { degrees: 180, reflectVertical: false, reflectHorizontal: false },
    4: { degrees: 0, reflectVertical: true, reflectHorizontal: false },
    5: { degrees: 270, reflectVertical: false, reflectHorizontal: true },
    6: { degrees: 90, reflectVertical: false, reflectHorizontal: false },
    7: { degrees: 90, reflectVertical: false, reflectHorizontal: true },
    8: { degrees: 270, reflectVertical: false, reflectHorizontal: false },
  },

  orientation(fileBuffer) {
    const scanner = new DataView(fileBuffer);
    let orientation = 1;

    if (scanner.getUint16(0) === 0xFFD8) {
      let idx = 0;
      let maxBytes = scanner.byteLength;

      while (idx < maxBytes - 2) {
        const uint16 = scanner.getUint16(idx);
        idx += 2;

        switch (uint16) {
          case 0xFFE1: // Set maxBytes so only exif data is read
            const exifLength = scanner.getUint16(idx);
            maxBytes = exifLength - idx;
            idx += 2;
            break;
          case 0x0112: // Read orientation tag
            orientation = scanner.getUint16(idx + 6, false);
            maxBytes = 0; // Stop scanning
            break;
        }
      }
    }
    return orientation;
  },
};

export default JPEGExif;
